import { Button, FormGroup, InlineValuePopover, Input, Label } from "@xola/ui-kit";
import clsx from "clsx";
import React from "react";

interface ChangeAmountPopoverProps {
    value: number;
    manualCounterValue: number;
    max: number;
    min: number;
    total: number;
    isOpen: boolean;
    popoverParentId?: string;
    className?: string;
    isError?: boolean;
    isManualError?: boolean;
    text?: string;
    onClick: () => void;
    onSubmit: () => void;
    onChange: (value: number) => void;
}

export const ChangeAmountPopover = ({
    value,
    manualCounterValue,
    max,
    min,
    total,
    isOpen,
    popoverParentId,
    className,
    isError = false,
    isManualError = false,
    text = "",
    onClick,
    onSubmit,
    onChange,
}: ChangeAmountPopoverProps) => {
    return (
        <div className={clsx("mx-3 min-w-[30px] text-center", className)}>
            <InlineValuePopover
                showArrow={false}
                text={
                    <span
                        className={clsx(className, { "text-danger": isError })}
                        data-testid="quantity-spinner-capacity"
                    >
                        {Number(Math.abs(manualCounterValue))}
                    </span>
                }
                isOpen={isOpen}
                classNames={{ text: "text-white", textField: isError && "border-b-danger" }}
                appendTo={popoverParentId && (() => document.querySelector(`#${popoverParentId}`))}
                distance={15}
                onClick={onClick}
                onClickOutside={onSubmit}
            >
                <FormGroup className="!mb-0 flex flex-col">
                    <div className="flex space-x-2">
                        <Input
                            type="tel" // To show only numbers and yet avoid the up and down number arrows that come with type number.
                            className="!w-30"
                            value={value}
                            isError={isManualError}
                            onFocus={(e: any) => e.target.select()}
                            onChange={onChange}
                        />
                        <Button disabled={isManualError} onClick={onSubmit}>
                            Apply
                        </Button>
                    </div>
                    {isManualError && (
                        <Label className="!mb-0 !text-danger">
                            {getError({ newValue: value, oldValue: manualCounterValue, max, min, total })}
                        </Label>
                    )}
                </FormGroup>
            </InlineValuePopover>
            <div className="leading-none">{text}</div>
        </div>
    );
};

interface getErrorProps {
    newValue: number;
    oldValue: number;
    max: number;
    min: number;
    total: number;
}

const getError = ({ newValue, oldValue, max, min, total }: getErrorProps) => {
    const newTotal = total === 0 ? newValue : total - oldValue + newValue;
    return newTotal > max ? `Quantity cannot exceed ${max}` : `Quantity cannot go below ${min}`;
};
